import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { IPasswordStrength } from '~domain/entities/Config';
import { Password } from '~domain/entities/Password';
import { PasswordRepository } from '~repositories/PasswordRepository';

interface IPasswordStrengthViewController {
    passwordRepository: PasswordRepository;
    passwordEntity: Password;
}

export class PasswordStrengthViewController extends ViewController {
    @observable private passwordStrengthProps: IPasswordStrength;
    @observable private totalLevel: number = 0;
    private passwordRepository: PasswordRepository;
    private passwordEntity: Password;

    constructor({ passwordRepository, passwordEntity }: IPasswordStrengthViewController) {
        super();
        this.passwordRepository = passwordRepository;
        this.passwordEntity = passwordEntity;
    }

    @action
    public loaded = async (props: IPasswordStrength) => {
        this.passwordStrengthProps = props;
        this.totalLevel = props.items.length - 1; // Index 0 is the default status
    };

    @computed
    public get data() {
        const { passwordDataStore } = this.passwordRepository;
        const passwordValue = passwordDataStore[this.passwordStrengthProps.passwordFieldName];
        const levelData = this.passwordEntity.getPasswordStrengthData({
            passwordValue,
            totalLevel: this.totalLevel,
            levelLabels: this.passwordStrengthProps.items
        });

        return {
            levelData,
            totalLevel: this.totalLevel,
            isShown: passwordValue ? true : false
        };
    }
}
